import settings from '@/settings'

let realizarLetura = (headers, data) => {
  return fetch(`${settings.apetrusApi}/vouchers/useByPos/`, {
    method: 'PUT',
    mode: 'cors',
    body: JSON.stringify(data),
    headers: headers
  })
}

let realizarLeturaCodigo = (headers, data) => {
  return fetch(`${settings.apetrusApi}/vouchers/realizarleitura/`, {
    method: 'PUT',
    mode: 'cors',
    body: JSON.stringify(data),
    headers: headers
  })
}

let pegarVoucherPremio = (headers, filtros) => {
  let url = `${settings.apetrusApi}/vouchers/pegarvoucherpremio/`

  if (filtros) {
    const keys = Object.keys(filtros)
    for (let i = 0; i < keys.length; i++) {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${keys[i]}=${filtros[keys[i]]}`
    }
  }

  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const cashPosto = (headers, data, method) => {
  let url = `${settings.apetrusApi}/vouchers/cashposto/`

  const parametros = {
    method: method,
    mode: 'cors',
    headers: headers
  }

  if (method === 'GET') {
    parametros.cache = 'default'
    if (data) {
      const keys = Object.keys(data)
      for (let i = 0; i < keys.length; i++) {
        url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${keys[i]}=${data[keys[i]]}`
      }
    }
  } else {
    parametros.body = JSON.stringify(data)
  }
  return fetch(url, parametros)
}

const gerarVoucherComCredito = (headers, data) => {
  return fetch(`${settings.apetrusApi}/vouchers/credito-funcionario/`, {
    method: 'POST',
    mode: 'cors',
    body: JSON.stringify(data),
    headers: headers
  })
}

let listVouchers = (cpf, headers) => {
  return fetch(`${settings.apetrusApi}/vouchers/porcpf/?cpf=${cpf}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}
/**
 * this function request a requisition for API in order to list all Vouchers available with that car
 *
 * @param  {} data
 * @param  {} headers
 */
let listVouchersplaca = (payload, headers) => {
  let url = `${settings.apetrusApi}/vouchers/porveiculo/`
  if (payload) {
    const keys = Object.keys(payload)
    for (let i = 0; i < keys.length; i++) {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${keys[i]}=${payload[keys[i]]}`
    }
  }
  return fetch(
    url,
    {
      method: 'GET',
      mode: 'cors',
      cache: 'default',
      headers: headers
    }
  )
}

let adicionarCupom = (data, compra, headers) => {
  return fetch(`${settings.apetrusApi}/vouchers/adicionarCupom/${compra}/`, {
    method: 'PUT',
    mode: 'cors',
    body: JSON.stringify(data),
    cache: 'default',
    headers: headers
  })
}

let editarCupom = (data, voucher, headers) => {
  return fetch(`${settings.apetrusApi}/vouchers/editarCupom/${voucher}/`, {
    method: 'PUT',
    mode: 'cors',
    body: JSON.stringify(data),
    cache: 'default',
    headers: headers
  })
}

let historyCaixa = (headers, payload) => {
  let url = `${settings.apetrusApi}/vouchers/historicoCaixa/`
  if (payload) {
    const keys = Object.keys(payload)
    for (let i = 0; i < keys.length; i++) {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${keys[i]}=${payload[keys[i]]}`
    }
  }
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let historyVouchers = (data, headers) => {
  let url = `${settings.apetrusApi}/vouchers/historyporfrentista/`

  if (data) {
    const keys = Object.keys(data)
    for (let i = 0; i < keys.length; i++) {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${keys[i]}=${data[keys[i]]}`
    }
  }
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let historyConvenioVouchers = (data, headers) => {
  let url = `${settings.apetrusApi}/vouchers/historicoconveniopdv/`

  if (data) {
    const keys = Object.keys(data)
    for (let i = 0; i < keys.length; i++) {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${keys[i]}=${data[keys[i]]}`
    }
  }
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let utilizarVoucherConvenio = (idVoucher, senha, idFrentista, cnpjEmpresa, headers) => {
  return fetch(`${settings.apetrusApi}/vouchers/utilizarconveniopdv/?empresa=${cnpjEmpresa}`, {
    method: 'PUT',
    mode: 'cors',
    body: JSON.stringify({
      id_voucher: idVoucher,
      senha: senha,
      id_frentista: idFrentista
    }),
    cache: 'default',
    headers: headers
  })
}

let useVoucher = (cpf, idVoucher, senha, idfrentista, hodometro, headers) => {
  return fetch(`${settings.apetrusApi}/vouchers/useByPos/?cpf=${cpf}&id_voucher=${idVoucher}`, {
    method: 'PUT',
    mode: 'cors',
    body: JSON.stringify({
      senha: senha,
      id_frentista: idfrentista,
      hodometro: hodometro
    }),
    cache: 'default',
    headers: headers
  })
}

/**
 * this function request change to API in order to use the Voucher per car
 *
 * @param  {} identificacao
 * @param  {} idVoucher
 * @param  {} senha
 * @param  {} headers
 */
let useVoucherPlaca = (identificacao, idVoucher, senha, idfrentista, hodometro, headers) => {
  return fetch(`${settings.apetrusApi}/vouchers/useByPos/`, {
    method: 'PUT',
    mode: 'cors',
    body: JSON.stringify({
      senha: '',
      id_frentista: idfrentista,
      hodometro: hodometro,
      placa: identificacao,
      id_voucher: idVoucher
    }),
    cache: 'default',
    headers: headers
  })
}

let cancelarAbastecimentoVoucher = (idVoucher, headers) => {
  return fetch(`${settings.apetrusApi}/vouchers/cancelarabastecimento/?id_voucher=${idVoucher}`, {
    method: 'PUT',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let voucherPremio = (data, headers) => {
  let url = `${settings.apetrusApi}/vouchers/voucherpremio/`

  if (data) {
    const keys = Object.keys(data)
    for (let i = 0; i < keys.length; i++) {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${keys[i]}=${data[keys[i]]}`
    }
  }
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let lerVoucherPremio = (data, headers) => {
  return fetch(`${settings.apetrusApi}/vouchers/voucherpremio/`, {
    method: 'PUT',
    mode: 'cors',
    body: JSON.stringify(data),
    cache: 'default',
    headers: headers
  })
}

let pegarVoucherCashpostoEmpresa = (data, headers) => {
  return fetch(`${settings.apetrusApi}/vouchers/cashpostoempresa/?codigo=${data.codigo}&empresa=${data.empresa}&id_frentista=${data.id_frentista}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let lerVoucherCashpostoEmpresa = (data, headers) => {
  return fetch(`${settings.apetrusApi}/vouchers/cashpostoempresa/`, {
    method: 'PUT',
    mode: 'cors',
    body: JSON.stringify(data),
    cache: 'default',
    headers: headers
  })
}

let historicoVoucherCashpostoEmpresa = (data, headers) => {
  return fetch(`${settings.apetrusApi}/vouchers/historicocashpostoempresa/?empresa=${data.empresa}&id_frentista=${data.id_frentista}&disponivel=False`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

export default {
  realizarLeturaCodigo,
  realizarLetura,
  pegarVoucherPremio,
  cashPosto,
  gerarVoucherComCredito,
  listVouchers,
  listVouchersplaca,
  adicionarCupom,
  editarCupom,
  historyCaixa,
  historyVouchers,
  historyConvenioVouchers,
  utilizarVoucherConvenio,
  useVoucher,
  useVoucherPlaca,
  cancelarAbastecimentoVoucher,
  voucherPremio,
  lerVoucherPremio,
  lerVoucherCashpostoEmpresa,
  pegarVoucherCashpostoEmpresa,
  historicoVoucherCashpostoEmpresa
}
